<template lang="pug">
  .switch
    .container.row.middle.relative(@click='toggle' :class='{active}')
      .button.absolute(:class='{active}')
</template>

<script>
export default {
  props: {
    value: { type: Boolean },
    name: { type: String }
  },
  data() {
    return {
      active: false
    }
  },
  mounted() {
    if (this.value) {
      this.active = this.value
    }
  },
  methods: {
    toggle() {
      this.active = !this.active
      this.$emit('change', this.name, this.active)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.switch{
  .container{
    width: 40px;
    height: 20px;
    padding: 2px;
    border-radius: 10px;
    background-color: $dark-gray;
    &.active{
      background-color: $blue;
    }
    transition: background-color .5s ease;
    cursor: pointer;
  }
  .button{
    width: 16px;
    height: 16px;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    background-color: $white;
    &.active{
      transform: translateX(20px);
    }
    transition: transform .5s ease, background-color .5s ease;
  }
}
</style>
